import moment from "moment";
import { ON_LEND, ON_RENT } from "../constants";
import { ContractAddresses } from "../contract/contract-constant";

export const getPlatformByEmail = (email) => {
  if (email === "dafi@dev.com") {
    return "dafi";
  } else if (email === "nitro@dev.com") {
    return "nitro";
  } else if (email === "pgen@dev.com") {
    return "pgen";
  } else if (email === "mimir@dev.com") {
    return "mimir";
  } else if (email === "poli@dev.com") {
    return "poli";
  } else if (email === "quidd@dev.com") {
    return "quidd";
  } else {
    return "dafi";
  }
};

export const getNetworkByEmail = (email) => {
  if (email === "dafi@dev.com") {
    return 2;
  } else if (email === "nitro@dev.com") {
    return 3;
  } else if (email === "pgen@dev.com") {
    return 3;
  } else if (email === "mimir@dev.com") {
    return 2;
  } else if (email === "poli@dev.com") {
    return 2;
  } else if (email === "quidd@dev.com") {
    return 4;
  }
  return 2;
};

export const getDaysByTimestamp = (timestamp) => {
  return timestamp ? `${timestamp / (60 * 60 * 24)} days` : 0;
};

export const getDaysToTimestamp = (timestamp) => {
  return Math.round(Math.abs(Date.now() / 1000 - timestamp) / 86400);
};

export const getRentedPeriodRemaining = (timestamp, duration) => {
  return (
    duration / 86400 -
    Math.round(Math.abs(Date.now() / 1000 - timestamp) / 86400)
  );
};

export const checkIfNftIsLent = (timeStamp, duration) => {
  return (Date.now() / 1000 - (timeStamp + duration)) / 86400 < 0
    ? true
    : false;
};

export const getPlatformChains = (platformId) => {
  let arr = [2, 3, 4];

  let chainsObject = {
    2: false,
    3: false,
    4: false,
  };

  arr.forEach((network) => {
    // networkContractAddresses[platformId][network].length > 0
    //   ? (chainsObject[network] = true)
    //   : (chainsObject[network] = false);

    ContractAddresses[platformId][network].stakingDatabase
      ? (chainsObject[network] = true)
      : (chainsObject[network] = false);
  });

  return chainsObject;
};

export const sixDigitsFormatter = (num) => {
  if (num < 1) {
    return num;
  }
  if (false && num <= 9999.99) {
    let amount = truncateExact(num, 2);
    return amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else if (false && num <= 999999.99) {
    let amount = Math.trunc(num);
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    const si = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" },
    ];
    // const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i;
    for (i = si.length - 1; i > 0; i--) {
      if (num >= si[i].value) {
        break;
      }
    }
    let amount = truncate(num / si[i].value) + si[i].symbol;
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

export const truncateExact = (num, fixed) => {
  if (num) {
    let sNumber = num.toString();
    let index = sNumber.indexOf(".");
    let newNumber = index !== 0 ? sNumber : "0" + sNumber;
    let re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
    let number = newNumber.toString().match(re);
    if (number) {
      return number[0];
    }
  } else {
    return num;
  }
};
export const truncate = (num) => {
  if (num) {
    const floatedTo = num >= 1 ? 2 : 3;
    let re = new RegExp("^-?\\d+(?:.\\d{0," + (floatedTo || -1) + "})?");
    let number = num?.toString()?.match(re);
    if (number) {
      return number[0];
    }
  } else {
    return num;
  }
};

function convertHMS(value) {
  const sec = parseInt(value, 10); // convert value to number if it's string
  console.log("value and sec", { value, sec });
  let hours = Math.floor(sec / 3600); // get hours
  let minutes = Math.floor((sec - hours * 3600) / 60); // get minutes
  let seconds = sec - hours * 3600 - minutes * 60; //  get seconds

  // add 0 if value < 10; Example: 2 => 02
  if (hours < 10) {
    hours = Number("0" + hours);
  }
  if (minutes < 10) {
    minutes = Number("0" + minutes);
  }
  if (seconds < 10) {
    seconds = Number("0" + seconds);
  }
  return { hours, minutes, seconds }; // Return is HH : MM : SS
}

export const calculateDaysFromTimestamp = (timestamp, seconds) => {
  console.log("timestamp", timestamp, seconds);

  let timeToExpire = (timestamp + seconds) * 1000;
  let remaingMilliSec = Math.abs(Date.now() - timeToExpire);
  console.log("remaingMilliSec", remaingMilliSec);
  const remaingDuration = convertHMS(remaingMilliSec / 1000);
  console.log("remaingDuration", remaingDuration);

  let durationTime = Math.abs(
    Date.now() / 1000 - (Number(timestamp) + Number(seconds))
  );

  console.log("durationTime", { durationTime, flag: durationTime / 86400 });

  let timestampOfEndedTime;
  let days;
  let hours;

  if (true || durationTime > 86400) {
    // Converting seconds to days
    days = seconds / (60 * 60 * 24);

    //  Adding days to timestamp(when specific thing started)
    timestampOfEndedTime = moment.unix(timestamp).add(days, "days").unix();
  } else {
    // Converting seconds to days
    hours = seconds / (60 * 60);

    timestampOfEndedTime = moment.unix(timestamp).add(hours, "hours").unix();
    console.log("timestampOfEndedTime", timestampOfEndedTime);
  }

  //  Adding days to timestamp(when specific thing started)
  // timestampOfEndedTime = moment.unix(timestamp).add(days, "days").unix();

  console.log("timestampOfEndedTime", timestampOfEndedTime);

  var x = moment(timestampOfEndedTime).from(new Date());

  console.log("x ==================", x);

  let differenceForEndTime = moment
    .unix(timestampOfEndedTime)
    .diff(moment.unix(moment().unix()), "hours");

  // Finding difference between both timestamps
  let differenceForEndTimeInHours = moment
    .unix(timestampOfEndedTime)
    .diff(moment.unix(moment().unix()), "hours");

  let differenceForEndTimeInDays = moment
    .unix(timestampOfEndedTime)
    .diff(moment.unix(moment().unix()), "days");

  let differenceForEndTimeInMinutes = moment
    .unix(timestampOfEndedTime)
    .diff(moment.unix(moment().unix()), "minutes");

  console.log("differenceForEndTime", differenceForEndTime);

  console.log("remaing duration", {
    days: differenceForEndTimeInDays,
    hours: differenceForEndTimeInHours,
    minutes: differenceForEndTimeInMinutes,
  });

  // if (differenceForEndTime < 0 || differenceForEndTime === 0) {
  //   return 0;
  // }

  return {
    days: differenceForEndTimeInDays,
    hours: differenceForEndTimeInHours,
    minutes: differenceForEndTimeInMinutes,
  };
};

export const conciseAddress = (address) => {
  // if (Web3.utils.isAddress(address)) {
  return `${address.slice(0, 5)}...${address.slice(
    address.length - 5,
    address.length
  )}`;
  // }
  // return "-";
};

export const mergeTowArrayItemsHavingCommonLendingId = (arr1, arr2) => {
  try {
    let res = [];

    for (let a of arr2) {
      const found = arr1.find((elem) => elem.lendingId === a.lendingId);
      // console.log("found", found);
      if (found) res.push({ ...a, ...found });
    }
    return res;
  } catch (er) {
    console.log("error in mergeTowArrayItemsHavingCommonLendingId", er);
  }
};

export const getUniqueLendingIdNfts = (arr1, arr2) => {
  try {
    let res = [];

    for (let a of arr1) {
      const found = arr2.find((elem) => elem.lendingId === a.lendingId);
      // console.log("found", found);
      if (!found) res.push({ ...a });
    }
    return res;
  } catch (er) {
    console.log("error in mergeTowArrayItemsHavingCommonLendingId", er);
  }
};

export const getUniqueItems = (arr1, arr2) => {
  let abc = arr1.filter(
    (nft1) =>
      !arr2.some(
        (nft2) =>
          nft2.nftAddress === nft1.nftAddress && nft2.tokenId === nft1.tokenId
      )
  );
  return [...abc, ...arr2];
};

export const addRentingDataforNftsOnRent = (arr1, arr2) => {
  try {
    const arr1WithRentedData = arr1.map((nft) => {
      let nftObj;
      let found = arr2.find((elem) => elem.lendingId === nft.lendingId);
      nftObj = {
        ...nft,
        ...found,
      };
      return nftObj;
    });
    // console.log("arr1WithRentedData", arr1WithRentedData);

    return arr1WithRentedData;
  } catch (er) {
    console.log("error in mergeTowArrayItemsHavingCommonLendingId", er);
  }
};

export const addLendingDataforNftsOnLend = (arr1, arr2) => {
  try {
    const arr1WithRentedData = arr1.map((nft) => {
      let nftObj;
      let found = arr2.find(
        (elem) =>
          elem.nftAddress === nft.nftAddress && elem.tokenId === nft.tokenId
      );
      if (found) {
        nftObj = {
          ...nft,
          ...found,
          status: ON_LEND,
        };
      } else {
        nftObj = {
          ...nft,
        };
      }

      return nftObj;
    });
    // console.log("arr1WithRentedData", arr1WithRentedData);

    return arr1WithRentedData;
  } catch (er) {
    console.log("error in mergeTowArrayItemsHavingCommonLendingId", er);
  }
};

export const updateStatusForRentedNfts = (arr1, arr2) => {
  try {
    const arr1WithRentedData = arr1.map((nft) => {
      let nftObj;
      let found = arr2.find((elem) => elem.lendingId === nft.lendingId);
      if (found) {
        nftObj = {
          ...nft,
          ...found,
          status: ON_RENT,
        };
      } else {
        nftObj = {
          ...nft,
        };
      }
      return nftObj;
    });
    // console.log("arr1WithRentedData", arr1WithRentedData);

    return arr1WithRentedData;
  } catch (er) {
    console.log("error in mergeTowArrayItemsHavingCommonLendingId", er);
  }
};

export const settingCollections = async (addresses, collectionsFromServer) => {
  try {
    let addressesToAddOnServer = [];
    // let collectionsToShow = [...collectionsFromServer];
    for (let a of addresses) {
      const found = collectionsFromServer.find(
        (elem) => elem.collectionAddresses === a
      );
      // console.log("found", found);
      if (!found) {
        // const contractData = await getNftContractMetadata(a)

        // const collection = {
        //   collectionAddresses: a,
        //   contracts: [a],
        //   adopter: a,
        //   name: contractData?.name,
        //   collectionNames: contractData?.name,
        //   profilePic: dummyCollectionCover,
        //   coverPic: dummyCollectionPic,
        //   isStake: true,
        // };

        addressesToAddOnServer.push(a);

        // get
        // collectionsToShow.push(collection);
      }
    }
    return addressesToAddOnServer;
  } catch (er) {
    console.log("error in settingCollections", er);
  }
};
